import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const MARESME_TOWNS = [
  'Alella', 'Arenys de Mar', 'Arenys de Munt', 'Argentona', 'Cabrera de Mar', 'Cabrils',
  'Caldes d\'Estrac', 'Canet de Mar','El Masnou','Mataró', 'Premià de Dalt', 'Premià de Mar', 'Sant Andreu de Llavaneres',
  'Sant Cebrià de Vallalta','Sant Pol de Mar','Sant Vicenç de Montalt', 'Santa Susanna', 'Vilassar de Dalt', 'Vilassar de Mar'
];

const Login = ({ setIsAuthenticated, setIsAdmin }) => {
  const [userCredentials, setUserCredentials] = useState({ name: '', town: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const savedName = localStorage.getItem('userName') || '';
    const savedTown = localStorage.getItem('userTown') || '';
    const token = localStorage.getItem('token');
    const expiresAt = localStorage.getItem('sessionExpiresAt');

    const isTokenValid = token && expiresAt && new Date() < new Date(expiresAt);
    setUserCredentials({ name: savedName, town: isTokenValid ? savedTown : '' });

    if (isTokenValid) {
      setIsAuthenticated(true);
      navigate('/');
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('sessionExpiresAt');
    }
  }, [setIsAuthenticated, navigate]);

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUserCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${apiUrl}/api/visits`, userCredentials);
      if (response.status === 201) {
        const expirationTime = new Date(Date.now() + 60 * 60 * 1000);

        localStorage.setItem('token', response.data.token);
        localStorage.setItem('isAdmin', 'false');
        localStorage.setItem('userName', userCredentials.name);
        localStorage.setItem('userTown', userCredentials.town);
        localStorage.setItem('sessionExpiresAt', expirationTime.toISOString());

        setIsAuthenticated(true);
        setIsAdmin(false);
        navigate('/');
      } else {
        throw new Error('No se pudo registrar la visita');
      }
    } catch (error) {
      console.error('Error al registrar la visita:', error);
      alert('Error al registrar la visita: ' + (error.response?.data?.message || error.message || 'Error desconocido'));
    }
  };

  return (
    <div className="login-container">
      <div className="logo-container">
        <div className="jewel-icon"></div>
        <p className="slogan">Un toque de luz para ti.</p>
      </div>
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="text"
          name="name"
          placeholder="Nombre"
          value={userCredentials.name}
          onChange={handleUserChange}
          required
        />

        <select
          name="town"
          value={userCredentials.town}
          onChange={handleUserChange}
          required
        >
          <option value="" disabled hidden>Selecciona tu población</option>
          {MARESME_TOWNS.map((town) => (
            <option key={town} value={town}>{town}</option>
          ))}
        </select>

        <p className="town-note">Actualmente solo entregamos en el Maresme. Añadiremos más poblaciones en breve.</p>

        <button type="submit">Visitar Boutique</button>
      </form>
    </div>
  );
};

export default Login;
